<mp-header></mp-header>
<div class="background">
  <router-outlet></router-outlet>
</div>
<mp-footer></mp-footer>
